export class JobProgressStepBucketDataRestorationData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "totalBytes",
            "baseName": "totalBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "totalObjects",
            "baseName": "totalObjects",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "bucketName",
            "baseName": "bucketName",
            "type": "string",
            "format": ""
        },
        {
            "name": "prefix",
            "baseName": "prefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "storageAccount",
            "baseName": "storageAccount",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountId",
            "baseName": "accountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountName",
            "baseName": "accountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "objectUri",
            "baseName": "objectUri",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepBucketDataRestorationData.attributeTypeMap;
    }
    constructor() {
    }
}
